module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_16_9_w_1341.84a8435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_16_9_w_1341.jpg
// module id = 6qeU
// module chunks = 0